import * as Yup from 'yup'



export const validationSchemas = (isAnular) => {
   
  let validationObject = { };
  if(isAnular){

    validationObject["comentario"] = Yup.string().required('Este campo es obligatorio.');
  }
  validationObject["idGestionAnalista"] = Yup.string().required('Este campo es obligatorio.');
  return Yup.object().shape(validationObject);
}

